import { ActionService, CommonService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';

export default (() => {
  const ON_CHANGE_USER_SELECTABLE_DROPDOWNS = 'ON_CHANGE_USER_SELECTABLE_DROPDOWNS_CUSTOM_INSIGHT'
  const onChangeUserSelectableDropdowns = ActionService.makeActionCreator(ON_CHANGE_USER_SELECTABLE_DROPDOWNS, 'value', 'name')

  const ON_CHANGE_MAP_CONFIG = 'ON_CHANGE_MAP_CONFIG_CUSTOM_INSIGHT'
  const onChangeMapConfig = ActionService.makeActionCreator(ON_CHANGE_MAP_CONFIG, 'value', 'name')

  const ON_CHANGE_SUMMARY_CONFIG = 'ON_CHANGE_SUMMARY_CONFIG_CUSTOM_INSIGHT'
  const onChangeSummaryConfig = ActionService.makeActionCreator(ON_CHANGE_SUMMARY_CONFIG, 'value', 'name')

  const ADD_MAP_DATA = 'ADD_MAP_DATA_CUSTOM_INSIGHT'
  const addMapData = ActionService.makeActionCreator(ADD_MAP_DATA)

  const REMOVE_MAP_DATA = 'REMOVE_MAP_DATA_CUSTOM_INSIGHT'
  const removeMapData = ActionService.makeActionCreator(REMOVE_MAP_DATA, 'index')

  const REORDER_MAP_DATA = 'REORDER_MAP_DATA_CUSTOM_INSIGHT'
  const reorderMapData = ActionService.makeActionCreator(REORDER_MAP_DATA, 'from', 'to')

  const DUPLICATE_MAP_DATA = 'DUPLICATE_MAP_DATA_CUSTOM_INSIGHT'
  const duplicateMapData = ActionService.makeActionCreator(DUPLICATE_MAP_DATA, 'index')

  const CHANGE_ELEMENT_IN_MAP_DATA = 'CHANGE_ELEMENT_IN_MAP_DATA_CUSTOM_INSIGHT'
  const changeElementInMapData = ActionService.makeActionCreator(CHANGE_ELEMENT_IN_MAP_DATA, 'value', 'name', 'index')

  const CHANGE_AXIS_IN_MAP_DATA = 'CHANGE_AXIS_IN_MAP_DATA_CUSTOM_INSIGHT'
  const changeAxisInMapData = ActionService.makeActionCreator(CHANGE_AXIS_IN_MAP_DATA, 'value', 'name', 'index', 'right')

  const CHANGE_AXIS_IN_SUMMARY = 'CHANGE_AXIS_IN_SUMMARY_CUSTOM_INSIGHT'
  const changeAxisInSummary = ActionService.makeActionCreator(CHANGE_AXIS_IN_SUMMARY, 'value', 'name', 'right')

  const ADD_DATA_TO_AXIS_IN_SUMMARY = 'ADD_DATA_TO_AXIS_IN_SUMMARY_CUSTOM_INSIGHT'
  const addDataToAxisInSummary = ActionService.makeActionCreator(ADD_DATA_TO_AXIS_IN_SUMMARY, 'right')

  const REMOVE_DATA_FROM_AXIS_IN_SUMMARY = 'REMOVE_DATA_TO_AXIS_IN_SUMMARY_CUSTOM_INSIGHT'
  const removeDataFromAxisInSummary = ActionService.makeActionCreator(REMOVE_DATA_FROM_AXIS_IN_SUMMARY, 'dataIndex', 'right')

  const REORDER_DATA_FROM_AXIS_IN_SUMMARY = 'REORDER_DATA_FROM_AXIS_IN_SUMMARY_CUSTOM_INSIGHT'
  const reorderDataFromAxisInSummary = ActionService.makeActionCreator(REORDER_DATA_FROM_AXIS_IN_SUMMARY, 'from', 'to', 'right')

  const CHANGE_DATA_IN_AXIS_IN_SUMMARY = 'CHANGE_DATA_IN_AXIS_IN_SUMMARY_CUSTOM_INSIGHT'
  const changeDataInAxisInSummary = ActionService.makeActionCreator(CHANGE_DATA_IN_AXIS_IN_SUMMARY, 'value', 'name', 'dataIndex', 'right')

  const ADD_DATA_TO_AXIS_IN_MAP_DATA = 'ADD_DATA_TO_AXIS_IN_MAP_CUSTOM_INSIGHT'
  const addDataToAxisInMapData = ActionService.makeActionCreator(ADD_DATA_TO_AXIS_IN_MAP_DATA, 'index', 'right')

  const REMOVE_DATA_FROM_AXIS_IN_MAP_DATA = 'REMOVE_DATA_FROM_AXIS_IN_MAP_DATA_CUSTOM_INSIGHT'
  const removeDataFromAxisInMapData = ActionService.makeActionCreator(REMOVE_DATA_FROM_AXIS_IN_MAP_DATA, 'dataIndex', 'mapIndex', 'right')

  const REORDER_DATA_FROM_AXIS_IN_MAP_DATA = 'REORDER_DATA_FROM_AXIS_IN_MAP_DATA_CUSTOM_INSIGHT'
  const reorderDataFromAxisInMapData = ActionService.makeActionCreator(REORDER_DATA_FROM_AXIS_IN_MAP_DATA, 'from', 'to', 'mapIndex', 'right')

  const CHANGE_DATA_IN_AXIS_IN_MAP_DATA = 'CHANGE_DATA_IN_AXIS_IN_MAP_DATA_CUSTOM_INSIGHT'
  const changeDataInAxisInMapData = ActionService.makeActionCreator(CHANGE_DATA_IN_AXIS_IN_MAP_DATA, 'value', 'name', 'index', 'dataIndex', 'right')

  const CONNECTION_TYPES = {
    DIRECT: "Direct",
    SEA_FULL: "Sea routes (full)",
    SEA_BASIC: "Sea routes (simplified)"
  }

  const getValueRowIndex = (values, choosenDate) => {
    const valueRowIndex = (values || []).findIndex(valueRow => valueRow.time === choosenDate)
    return valueRowIndex;
  }

  const counterKeysFilter = ({ countryName, symbol, symbolList, column, groupName, userSelectableDropdowns, metadataMap, geometryName, geojson, debug = false }) => {
    let isEqual = true
    if(debug) {
      // you can put your debug console log here
    }
    // if we have different column
    if(
      (String(symbol.valueName).toLowerCase() !== String(column).toLowerCase())
      && ((symbol.valueNames || []).findIndex(v => v.toLowerCase() === String(column).toLowerCase()) === -1)
    ) {
      return false;
    }
    if(geojson === GEOJSONS.CUSTOM?.value && ( // if geometry is custom
      (
        String(metadataMap[symbol.metadataIds[0]]?.source?.column?.metadata[geometryName]).toLowerCase() !== String(countryName).toLowerCase() && // our geometry name does not fit the metadata selected
        String(symbol.symbols[geometryName]).toLowerCase() !== String(countryName).toLowerCase() // and does fits the symbol if symbol is geometry name and geometry is still custom
      )
        || ((groupName || symbolList?.[0]?.groupName) !== symbol.groupName)) // or group is not the same
      ) {
        return false; // then this is not our key
    }
    // if above is correct, let's check the symbol list now
    (symbolList || []).forEach(({ fixedValue, on, name: symbolName, userSelectable, groupName: deprecatedGroupName, autoGenerated, operation }) => {
      // if switch is on
      if(on && geojson !== GEOJSONS.CUSTOM?.value && geojson) {
        // we have to check if the geometry match the symbol and the group
        if(String(symbol.symbols[symbolName]).toLowerCase() === String(countryName).toLowerCase() && ((groupName || deprecatedGroupName) === symbol.groupName)) {
          // isEqual is true
        } else {
          isEqual = false
        }
      } else {
        // if it does not fit the above, we check the group, and the value for "Any" and user selectable dropdowns
        if((symbol.groupName === (groupName || deprecatedGroupName)) && (
          userSelectableDropdowns[symbolName] === symbol.symbols[symbolName] ||
          (symbol.symbols[symbolName] === fixedValue && (!userSelectable || !userSelectableDropdowns[symbolName])) || 
          symbol.symbols[symbolName] === "*" || 
          fixedValue === "*" || 
          symbol.symbols[symbolName] === countryName || 
          (autoGenerated && operation))
        ) {
          // symbol is fine, we do not change isEqual
        } else {
          // finally it does not equal
          isEqual = false
        }
      }
    })
    return isEqual;
  }

  const getCountryKey = ({ countryName, symbols, symbolList = [], column, groupName, userSelectableDropdowns, metadataMap = {}, geometryName, geojson, debug = false }) => {
    const key = Object.entries(symbols || {}).find(([, symbol]) => counterKeysFilter({ countryName, symbol, symbolList, column, groupName, userSelectableDropdowns, metadataMap, geometryName, geojson, debug }))?.[0]
    return key;
  }

  const getCountryKeys = ({ countryName, symbols, symbolList = [], column, groupName, userSelectableDropdowns, metadataMap = {}, geometryName, geojson, debug = false }) => {
    const keys = Object.entries(symbols || {}).filter(([, symbol]) => counterKeysFilter({ countryName, symbol, symbolList, column, groupName, userSelectableDropdowns, metadataMap, geometryName, geojson, debug }))?.map(([k]) => k)
    return keys;
  }

  const getLineKeyFilter = ({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbol, symbolList, column, groupName, userSelectableDropdowns, metadataMap, debug }) => {
    let isEqual = true
    if(debug) {
      // you can put your debug console log here
    }
    // if we have different column
    if(
      (String(symbol.valueName).toLowerCase() !== String(column).toLowerCase())
      && ((symbol.valueNames || []).findIndex(v => v.toLowerCase() === String(column).toLowerCase()) === -1)
    ) {
      return false;
    }
    if((groupName || symbolList?.[0]?.groupName) !== symbol.groupName) {
      return false;
    }
    if((
        String(metadataMap[symbol.metadataIds[0]]?.source?.column?.metadata[String(originGeometryName).trim()]).toLowerCase().trim() !== String(originFeatureName).toLowerCase().trim() &&
        String(symbol.symbols[String(originGeometryName).trim()]).toLowerCase().trim() !== String(originFeatureName).toLowerCase().trim()
      ) || (
        String(metadataMap[symbol.metadataIds[0]]?.source?.column?.metadata[String(destGeometryName).trim()]).toLowerCase().trim() !== String(destFeatureName).toLowerCase().trim() &&
        String(symbol.symbols[String(destGeometryName).trim()]).toLowerCase().trim() !== String(destFeatureName).toLowerCase().trim()
      )
    ) {
      return false;
    }
    // if above is correct, let's check the symbol list now
    (symbolList || []).forEach(({ fixedValue, name: symbolName, userSelectable, groupName: deprecatedGroupName, autoGenerated, operation }) => {
      // if it does not fit the above, we check the group, and the value for "Any" and user selectable dropdowns
      if((symbol.groupName === (groupName || deprecatedGroupName)) && (
        (symbol.symbols[symbolName] === fixedValue && (!userSelectable || !userSelectableDropdowns[symbolName])) || 
        symbol.symbols[symbolName] === "*" || 
        fixedValue === "*" || 
        symbol.symbols[symbolName] === originFeatureName || 
        symbol.symbols[symbolName] === destFeatureName || 
        (userSelectable && symbol.symbols[symbolName] === userSelectableDropdowns[symbolName]) || 
        (autoGenerated && operation))
      ) {
        // symbol is fine, we do not change isEqual
      } else {
        // finally it does not equal
        isEqual = false
      }
    })
    return isEqual;
  }

  const getLineKey = ({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbols, symbolList = [], column, groupName, userSelectableDropdowns, metadataMap = {}, debug = false }) => {
    const key = Object.entries(symbols || {}).find(([, symbol]) => getLineKeyFilter({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbol, symbolList, column, groupName, userSelectableDropdowns, metadataMap, debug }))?.[0]
    return key;
  }

  const getLineKeys = ({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbols, symbolList = [], column, groupName, userSelectableDropdowns, metadataMap = {}, debug = false }) => {
    const key = Object.entries(symbols || {}).filter(([, symbol]) => getLineKeyFilter({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbol, symbolList, column, groupName, userSelectableDropdowns, metadataMap, debug }))?.map(([k]) => k)
    return key;
  }

  const GEOJSONS = {
    COUNTRIES: {
      label: "Countries",
      value: "countries.json"
    },
    STATES: {
      label: "USA States",
      value: "UsStates.json"
    },
    STATES_AND_CANADA: {
      label: "USA States and Canada",
      value: "combinedUsCanada.js"
    },
    ISO_REGIONS: {
      label: "ISO Regions",
      value: "PowerMarkets.json"
    },
    CUSTOM: {
      label: "Custom",
      value: "CUSTOM"
    }
  }

  const getMapDateFormatSelector = state => {
    const localDateFormat = state.insightState.customState.content?.mapConfig?.dateFormat
    if(localDateFormat) {
      return TimeService.translateFormat(localDateFormat);
    }
    const dataprep = state.insightState.customState.datapreps["0"]
    if(dataprep?.dateFormat) {
      return TimeService.translateFormat(dataprep?.dateFormat)
    }
    return dataprep?.dateFormat;
  }

  // valueRowIndexExternal is for optimization -> we do not recalculate so much
  const emptyArray = []
  const emptyObj = {}
  const getFeatureData = (state, dataIndex, name, valueRowIndexExternal = undefined) => {
    const isNotSummary = dataIndex !== undefined,
          { choosenDate, symbols = emptyObj, values = emptyArray, userSelectableDropdowns = emptyObj, metadataMap = emptyObj, summaryData = emptyArray, shortDataprep } = state.insightState.customState,
          { symbolList = emptyArray, column, geometryName, geojsonType, geojson = geojsonType === "line" ? GEOJSONS.CUSTOM?.value : undefined, groupName, title, autoGenerated = false } = isNotSummary ? (state.insightState.customState.content?.mapData?.[dataIndex] || emptyObj) : (state.insightState.customState?.content?.summaryConfig || emptyObj)

    const index = isNotSummary ? symbolList.findIndex(s => s?.autoGenerated === true && s?.operation) : -1
    const valueRowIndex = valueRowIndexExternal !== undefined ? valueRowIndexExternal : getValueRowIndex(values, choosenDate)
    let localValue, localPrevValue
    if(index !== -1) {
      let keys 
      if(isNotSummary) { 
        keys = getCountryKeys({ countryName: name, symbols, symbolList, column, groupName, userSelectableDropdowns, metadataMap, geometryName, geojson })
        let sum = 0, prevSum = 0, counter = 0, prevCounter = 0
        keys.forEach(key => {
          if(values[valueRowIndex]?.values[key]) {
            sum += Number(values[valueRowIndex]?.values[key])
            counter++
          } 
          if(values[valueRowIndex + 1]?.values[key]) {
            prevSum += Number(values[valueRowIndex + 1]?.values[key])
            prevCounter++
          } 

        })
        localValue = counter ? symbolList[index]?.operation === operations.SUM.value ? sum : CommonService.roundNumber(sum/counter, shortDataprep?.decimalPrecision) : undefined
        localPrevValue = prevCounter ? symbolList[index]?.operation === operations.SUM.value ? prevSum : CommonService.roundNumber(prevSum/prevCounter, shortDataprep?.decimalPrecision) : undefined
      }
    } else {
      let key
      if(dataIndex !== undefined || !summaryData || !autoGenerated) {
        key = getCountryKey({ countryName: name, symbols, symbolList, column, groupName, userSelectableDropdowns, metadataMap, geometryName, geojson })
        localValue = values[valueRowIndex]?.values[key] ? Number(values[valueRowIndex]?.values[key]) : undefined
        localPrevValue = values[valueRowIndex + 1]?.values[key] ? Number(values[valueRowIndex + 1]?.values[key]) : undefined 
      } else {
        localValue = summaryData[valueRowIndex]?.[title]
        localPrevValue = summaryData[valueRowIndex + 1]?.[title]
      }
    }
    return {
      value: localValue,
      prevValue: localPrevValue,
      prevDate: values[valueRowIndex + 1]?.time,
      date: values[valueRowIndex]?.time,
      change: localValue !== undefined && localPrevValue !== undefined ? CommonService.fixedNumber(localValue - localPrevValue, 2) : undefined
    }
  }

  const getFeatureLineData = ({ state, dataIndex, originFeatureName, destFeatureName, valueRowIndex: valueRowIndexExternal = undefined }) => {
    const { choosenDate, symbols = {}, values = [], userSelectableDropdowns = {}, metadataMap = {}, shortDataprep } = state.insightState.customState,
          { symbolList = [], column, groupName, autoGenerated = false, originGeometryName, destGeometryName } = state.insightState.customState.content?.mapData?.[dataIndex] || {}
    const index = symbolList.findIndex(s => s?.autoGenerated === true && s?.operation)
    const valueRowIndex = valueRowIndexExternal !== undefined ? valueRowIndexExternal : getValueRowIndex(values, choosenDate)
    let localValue, localPrevValue
    if(index !== -1) {
      const keys = getLineKeys({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbols, symbolList, column, groupName, userSelectableDropdowns, metadataMap })
      let sum = 0, prevSum = 0, counter = 0, prevCounter = 0
      keys.forEach(key => {
        if(values[valueRowIndex]?.values[key]) {
          sum += Number(values[valueRowIndex]?.values[key])
          counter++
        } 
        if(values[valueRowIndex + 1]?.values[key]) {
          prevSum += Number(values[valueRowIndex + 1]?.values[key])
          prevCounter++
        }

      })
      localValue = counter ? symbolList[index]?.operation === operations.SUM.value ? sum : CommonService.roundNumber(sum/counter, shortDataprep?.decimalPrecision) : undefined
      localPrevValue = prevCounter ? symbolList[index]?.operation === operations.SUM.value ? prevSum : CommonService.roundNumber(prevSum/prevCounter, shortDataprep?.decimalPrecision) : undefined
    } else {
      let key
      if(dataIndex !== undefined || !autoGenerated) {
        key = getLineKey({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbols, symbolList, column, groupName, userSelectableDropdowns, metadataMap, debug: originFeatureName === "Das Island" && destFeatureName === "Ennore LNG" })
        localValue = values[valueRowIndex]?.values[key] ? Number(values[valueRowIndex]?.values[key]) : undefined
        localPrevValue = values[valueRowIndex + 1]?.values[key] ? Number(values[valueRowIndex + 1]?.values[key]) : undefined 
      }
    }
    return {
      value: localValue,
      prevValue: localPrevValue,
      prevDate: values[valueRowIndex + 1]?.time,
      date: values[valueRowIndex]?.time,
      change: localValue !== undefined && localPrevValue !== undefined ? CommonService.fixedNumber(localValue - localPrevValue, 2) : undefined
    }
  }

  const calculateAutoGenerated = ({ keys, valueRow, operation, decimalPrecision }) => {
    const value = keys.reduce((prev, curr) => {
      if(valueRow?.values[curr]) {
        prev.sum += Number(valueRow?.values[curr])
        prev.counter += 1;
      }
      return prev
    }, { sum: 0, counter: 0 })
    return value.counter ? operation === operations.SUM.value ? value.sum : CommonService.roundNumber(value.sum/value.counter, decimalPrecision) : undefined
  }

  const calculateStandard = ({ summaryData, name, autoGenerated, valueRow, key, title }) => !summaryData || name || !autoGenerated ? (valueRow.values[key] !== undefined && valueRow.values[key] !== null ? Number(valueRow.values[key]) : undefined) : summaryData.find(s => s.time === valueRow.time)?.[title]

  const calculateChartData = ({ calculateMethod, valueRowIndex, values, otherKeys, label, title }) => {
    const toReturn = values.slice(valueRowIndex < 12 ? 0 : valueRowIndex - 12, valueRowIndex <= values.length - 13 ? valueRowIndex + 13 : values.length).map(valueRow => {
      let basicObj = {
        [label || title]: calculateMethod(valueRow),
        time: valueRow.time
      }
      otherKeys.forEach(({ label, key }) => {
        basicObj = Object.assign({}, basicObj, { [label]: valueRow.values[key] !== undefined && valueRow.values[key] !== null ? Number(valueRow.values[key]) : undefined })
      })
      return basicObj;
    })
    return toReturn.reverse()
  }
  

  const getFeatureChartData = ({ state, dataIndex = undefined, mainName: name = undefined, valueRowIndexExternal = undefined, chartName = undefined }) => {
    const { choosenDate, symbols = {}, values = [], userSelectableDropdowns = {}, metadataMap = {}, summaryData = [], shortDataprep } = state.insightState.customState,
          { symbolList = [], label, column, groupName, title, geometryName, geojsonType, geojson = geojsonType === "line" ? GEOJSONS.CUSTOM?.value : undefined, autoGenerated = false, autoGeneratedOperation } = name ? (state.insightState.customState.content?.mapData?.[dataIndex] || {}) : (state.insightState.customState?.content?.summaryConfig || {})
    let leftAxisData, rightAxisData
    if(name) {
      leftAxisData = state.insightState.customState.content?.mapData?.[dataIndex]?.chartData?.leftAxis?.data || []
      rightAxisData = state.insightState.customState.content?.mapData?.[dataIndex]?.chartData?.rightAxis?.data || []
    } else {
      leftAxisData = state.insightState.customState.content?.summaryConfig?.chartData?.leftAxis?.data || []
      rightAxisData = state.insightState.customState.content?.summaryConfig?.chartData?.rightAxis?.data || []
    }
    const index = name && symbolList.findIndex(s => s?.autoGenerated === true && s?.operation)
    const valueRowIndex = valueRowIndexExternal !== undefined ? valueRowIndexExternal : getValueRowIndex(values, choosenDate)
    const otherKeys = leftAxisData.concat(rightAxisData).map(({ symbolList = [], column: columnLocal, label, groupName }) => ({ key: getCountryKey({ countryName: chartName || name, symbols, symbolList, column: columnLocal, groupName, userSelectableDropdowns, metadataMap, geometryName, geojson }), label }))
    if(index !== -1) {
      const keys = getCountryKeys({ countryName: name, symbols, symbolList, column, groupName, userSelectableDropdowns, metadataMap, geometryName, geojson })
      return calculateChartData({ 
        calculateMethod: valueRow => calculateAutoGenerated({ keys, valueRow, operation: symbolList[index]?.operation || autoGeneratedOperation, decimalPrecision: shortDataprep?.decimalPrecision }),
        valueRowIndex, 
        values, 
        otherKeys, 
        label, 
        title
      })
    } else {
      let key; 
      if(!summaryData || name || !autoGenerated) {
        key = getCountryKey({ countryName: name, symbols, symbolList, column, groupName, userSelectableDropdowns, metadataMap, geometryName, geojson })
      }
      return calculateChartData({ 
        calculateMethod: valueRow => calculateStandard({ summaryData, name, autoGenerated, valueRow, key, title }),
        valueRowIndex, 
        values, 
        otherKeys, 
        label, 
        title
      })
    }
  }

  const getLineFeatureChartData = ({ state, dataIndex = undefined, valueRowIndexExternal = undefined, originFeatureName, destFeatureName }) => {
    const { choosenDate, symbols = {}, values = [], userSelectableDropdowns = {}, metadataMap = {}, shortDataprep } = state.insightState.customState,
          { symbolList = [], label, column, groupName, title, originGeometryName, destGeometryName, autoGenerated = false } = state.insightState.customState.content?.mapData?.[dataIndex] || {}
    const leftAxisData = state.insightState.customState.content?.mapData?.[dataIndex]?.chartData?.leftAxis?.data || []
    const rightAxisData = state.insightState.customState.content?.mapData?.[dataIndex]?.chartData?.rightAxis?.data || []
    const index = symbolList.findIndex(s => s?.autoGenerated === true && s?.operation)
    const valueRowIndex = valueRowIndexExternal !== undefined ? valueRowIndexExternal : getValueRowIndex(values, choosenDate)
    const otherKeys = leftAxisData.concat(rightAxisData).map(({ symbolList = [], column: columnLocal, label, groupName }) => ({ 
      key: getLineKey({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbols, symbolList, column: columnLocal, groupName, userSelectableDropdowns, metadataMap }),
      label
     }))
    if(index !== -1) {
      const keys = getLineKeys({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbols, symbolList, column, groupName, userSelectableDropdowns, metadataMap })
      return calculateChartData({ 
        calculateMethod: valueRow => calculateAutoGenerated({ keys, valueRow, operation: symbolList[index]?.operation, decimalPrecision: shortDataprep?.decimalPrecision }),
        valueRowIndex, 
        values, 
        otherKeys, 
        label, 
        title
      })
    } else {
      const key = getLineKey({ originGeometryName, destGeometryName, originFeatureName, destFeatureName, symbols, symbolList, column, groupName, userSelectableDropdowns, metadataMap })
      return calculateChartData({ 
        calculateMethod: valueRow => calculateStandard({ name: originFeatureName + destFeatureName, autoGenerated, valueRow, key, title }),
        valueRowIndex, 
        values, 
        otherKeys, 
        label, 
        title
      })
    }
  }
  
  const emptyFeature = {
    type: "Feature",
    properties: {}
  }

  const getShapeFeatures = ({ metadataMap, shapeSource, geometryName }) => {
    const toReturn = []
    if(!shapeSource || !geometryName) {
      return toReturn;
    }
    console.warn("Getting the shape features");
    Object.values(metadataMap || {}).forEach(metadataMapElement => {
      const { metadata, symbols } = metadataMapElement?.source?.column || {},
            name = metadata[geometryName] || symbols[geometryName] || "Name"
      if(toReturn.findIndex(tr => tr.properties.name === name) > -1) {
        return;
      }
      const shape = metadata[shapeSource] || symbols[shapeSource]
      if(shape && shape.type === "Feature") {
        toReturn.push(Object.assign({}, emptyFeature, {
          geometry: {
            type: "Polygon", // TODO add support for multipolygons
            coordinates: shape
          },
          properties : {
            name
          }
        }))
      }
    })
    return toReturn; 
  }

  const getPointFeatures = ({ metadataMap, latSource, lonSource, geometryName }) => {
    const toReturn = []
    if(!latSource || !lonSource || !geometryName) {
      return toReturn
    }
    console.warn("Getting the point features");
    Object.values(metadataMap || {}).forEach(metadataMapElement => {
      const { metadata, symbols } = metadataMapElement?.source?.column || {},
            name = metadata[geometryName] || symbols[geometryName] || "Name"
      if(toReturn.findIndex(tr => tr.properties.name === name) > -1) {
        return;
      }
      const lat = metadata[latSource] || symbols[latSource],
            lon = metadata[lonSource] || symbols[lonSource]

      if(lat && lon) {
        toReturn.push(Object.assign({}, emptyFeature, {
          geometry: {
            type: "Point",
            coordinates: [Number(lat), Number(lon)]
          },
          properties : {
            name
          }
        }))
      }
    })
    return toReturn;
  }

  const getLineFeatures = ({ metadataMap, originLatSource, originLonSource, destLatSource, destLonSource, originGeometryName, destGeometryName }) => {
    const toReturn = []
    if(!originLatSource || !originLonSource || !destLatSource || !destLonSource || !originGeometryName || !destGeometryName) {
      return toReturn
    }
    console.warn("Getting the line features");
    Object.values(metadataMap || {}).forEach(metadataMapElement => {
      const { metadata, symbols } = metadataMapElement?.source?.column || {},
            originName = metadata[originGeometryName] || symbols[originGeometryName] || "OriginName",
            destName = metadata[destGeometryName] || symbols[destGeometryName] || "DestName"
      if(toReturn.findIndex(tr => tr.properties.originName === originName && tr.properties.destName === destName) > -1) {
        return;
      }
      const originLat = metadata[originLatSource] || symbols[originLatSource],
            originLon = metadata[originLonSource] || symbols[originLonSource],
            destLat  = metadata[destLatSource] || symbols[destLatSource],
            destLon = metadata[destLonSource] || symbols[destLonSource]
      if(originLat && originLon && destLat && destLon) {
        toReturn.push(Object.assign({}, emptyFeature, {
          geometry: {
            type: "LineString",
            coordinates: [[Number(originLat), Number(originLon)], [Number(destLat), Number(destLon)]]
          },
          properties : {
            originName,
            destName
          }
        }))
      }
    })
    return toReturn;
  }

  const operations = {
    SUM: {
      label: "Sum",
      value: "SUM"
    },
    AVERAGE: {
      label: "Average",
      value: "Average"
    }
  }

  const LATEST = "LATEST"

  return {
    ON_CHANGE_USER_SELECTABLE_DROPDOWNS,
    onChangeUserSelectableDropdowns,
    ON_CHANGE_MAP_CONFIG,
    onChangeMapConfig,
    ON_CHANGE_SUMMARY_CONFIG,
    onChangeSummaryConfig,
    ADD_MAP_DATA,
    addMapData,
    REMOVE_MAP_DATA,
    removeMapData,
    REORDER_MAP_DATA,
    reorderMapData,
    CHANGE_ELEMENT_IN_MAP_DATA,
    changeElementInMapData,
    CHANGE_AXIS_IN_MAP_DATA,
    changeAxisInMapData,
    CHANGE_AXIS_IN_SUMMARY,
    changeAxisInSummary,
    ADD_DATA_TO_AXIS_IN_SUMMARY,
    addDataToAxisInSummary,
    REMOVE_DATA_FROM_AXIS_IN_SUMMARY,
    removeDataFromAxisInSummary,
    REORDER_DATA_FROM_AXIS_IN_SUMMARY,
    reorderDataFromAxisInSummary,
    CHANGE_DATA_IN_AXIS_IN_SUMMARY,
    changeDataInAxisInSummary,
    ADD_DATA_TO_AXIS_IN_MAP_DATA,
    addDataToAxisInMapData,
    REMOVE_DATA_FROM_AXIS_IN_MAP_DATA,
    removeDataFromAxisInMapData,
    REORDER_DATA_FROM_AXIS_IN_MAP_DATA,
    reorderDataFromAxisInMapData,
    CHANGE_DATA_IN_AXIS_IN_MAP_DATA,
    changeDataInAxisInMapData,
    getValueRowIndex,
    GEOJSONS,
    getMapDateFormatSelector,
    getFeatureData,
    getFeatureChartData,
    getShapeFeatures,
    getPointFeatures,
    getLineFeatures,
    operations,
    LATEST,
    getFeatureLineData,
    getLineFeatureChartData,
    duplicateMapData,
    DUPLICATE_MAP_DATA,
    CONNECTION_TYPES
  }
})()